export const APP_TITLE = 'GameDay';
export const API_URL = import.meta.env.VITE_API_URL;
export const ENABLE_MOCKING = import.meta.env.VITE_ENABLE_MOCKING === '1';
export const MOCK_DELAY = import.meta.env.VITE_MOCK_DELAY;
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL!;
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY!;
export const ATHLETIKO_URL =
  import.meta.env.VITE_ATHLETIKO_URL || 'https://dpdev.athletiko.gr';
